export default __webpack_public_path__ + "static/media/bolero.38b69c96.jpg";